import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import '../index.css';
   

const UnauthorizedNavbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

      const handleSubscribe = (store) => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      if (store === "android") {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.bossinvestor.app";
      } else if (store === "ios") {
        window.location.href =
          "https://apps.apple.com/us/app/example-app/id123456789"; // replace with real ID
      }
    } else {
      setShowPopup(true);
    }
  };

  return (
    
    <nav className="navbar navbar-expand-lg navbar-light bg-white" style={{padding: '20px'}}>
      <div className="container-fluid">
        {/* Logo aligned to left */}
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
        <img
          src="/bossinvestorLogo.png"
          alt="BossInvestor Logo"
          style={{ width: '48px', height: '48px', objectFit: 'contain', paddingBottom:'5px' }}
        />
        <span
          style={{
            fontSize: '1.75rem',
            fontWeight: '700',
            lineHeight: '1',
            color: '#434242ff',
          }}
        >
          BossInvestor
        </span>
      </Link>

        {/* Mobile menu toggle button */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
        >
          <FaBars />
        </button>

        {/* Nav links aligned to right */}
        <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-auto d-flex align-items-center"
              style={{ gap: '2px' }}   // 👈 modern spacing control
            >
            <li className="nav-item">
              <Link className="nav-link " style={{fontSize: '1.5rem', lineHeight: '2rem', fontWeight: '600'}} to="/" onClick={closeMenu}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link " style={{fontSize: '1.5rem', lineHeight: '2rem', fontWeight: '600'}} to="/model-portfolio" onClick={closeMenu}>
                Portfolios
              </Link>
            </li>
             <li className="nav-item">
              <Link className="nav-link " style={{fontSize: '1.5rem', lineHeight: '2rem', fontWeight: '600'}} to="/stockIdeas" onClick={closeMenu}>
                Stock Ideas
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link " style={{fontSize: '1.5rem', lineHeight: '2rem', fontWeight: '600'}} to="/backtester" onClick={closeMenu}>
                Backtester
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link " style={{fontSize: '1.5rem', lineHeight: '2rem', fontWeight: '600'}} to="/blogs" onClick={closeMenu}>
                Blogs
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link className="nav-link fw-bold" to="/services" onClick={closeMenu}>
                Services
              </Link>
            </li> */}
            {/* <li className="nav-item">
              <Link className="nav-link " style={{fontSize: '1.5rem', lineHeight: '2rem', fontWeight: '600'}} to="/aboutUs" onClick={closeMenu}>
                About Us
              </Link>
            </li> */}
            {/* <li className="nav-item">
              <Link className="nav-link fw-bold" to="/contactUs" onClick={closeMenu}>
                Contact Us
              </Link>
            </li> */}
            <a onClick={() => handleSubscribe("android")} className="btn-secondary text-decoration-none" style={{paddingTop: '3px', paddingBottom: '5px', paddingLeft:'10px', paddingRight:'8px'}}>
              Download App
            </a>
          </ul>
        </div>
      </div>
      {showPopup && (
        <div className="qr-overlay" onClick={() => setShowPopup(false)}>
          
          <div className="qr-modal" onClick={(e) => e.stopPropagation()}>

            <button className="qr-close-icon" onClick={() => setShowPopup(false)}>
              ✕
            </button>

            <h2 className="qr-title">Get the Bossinvestor App</h2>
            <img 
              src="/playstoreScanner.jpeg" 
              alt="QR Code" 
              style={{ width: "170px", height: "170px", borderRadius: "12px" }}
            />
            <p className="qr-subtitle">
              Scan the QR code to download the app
            </p>

          </div>
        </div>
      )}
    </nav>
  );
};

export default UnauthorizedNavbar;
